<template>
    <d-card class="card-small mb-5">
      <spinner-dot v-if="loading" />
      <div v-else>
        <div class="header-data-table">
          <h5 class="header-data-table__heading">Mes demandes de contrat</h5>
        </div>
        <data-table
          :data="contractGridData"
          :fields="gridColumnsTitle"
          :selectedFields="contractFields"
          :fieldsGrid="gridColumnsFields"
          :tableState="state"
          :count="count"
        ></data-table>
      </div>
      <simple-modal ref="reasonModal" :motif="selectedMotif" />
    </d-card>
  </template>
  
  <script>
  import SpinnerDot from "../layout/Loading/spinner-dot";
  import DataTable from "./dataTable";
  import absceneRequestGrid from "../../data/dataTable/absceneRequestGrid.json";
  import SimpleModal from "../abscenceRequest/SimpleModal.vue";
  
  export default {
    name: "HistoryDaysOff",
    components: { SimpleModal, DataTable, SpinnerDot },
    props: ["reference"],
    data() {
      return {
        contractHistory: [],
        count: 0,
        model: {},
        contractType: {
          "CEE" : "CEE",
          "LEARN": "Apprentissage",
          "UNPAID": "Bénévole",
          "CDD": "CDD PEC",
          "CDI": "CDI",
          "OTHER": "Autre"
        },
        selectedMotif: "",
        allStructures: [],
        gridColumnsFields: absceneRequestGrid.grid,
        gridColumnsTitle: absceneRequestGrid.grid.map((grid) => grid.title),
        loading: true,
        contractFields: [
          "Date",
          "Structure",
          "Vacataire",
          "Type de contrat",
          "Statut",
          "Actions",
        ],
        contractFieldsGridFill: {
          "Date": (request) => new Date(request.creationDate).toLocaleDateString("fr-FR"),
          Structure: (request) => this.getStructureName(request.structureID) ,
          Vacataire: (request) => request.firstName + " " + request.lastName,
          "Type de contrat": (request) => this.contractType[request.typeOfContract] ,
          Statut: (request) => request.answers[0].status || "En attente...",
          Actions: (request) => {
            if (request.refuseReason) {
              return {
                component: "button-td",
                class: "HistoryDemands-refuseButton",
                icon: "fa fa-eye",
                action: this.showReason,
                id: request.refuseReason,
                content: "Voir les commentaires"
              };
            } else if (request.typeOfContract == "CEE") {
              return {
                component: "button-td",
                class: "HistoryDemands-refuseButton",
                icon: "fa fa-eye",
                action: this.goToContract,
                props: {reference :request.reference},
                id: request.reference,
                content: "Voir la demande"
              };
            }
            return "";
          },
        },
        state: {
          page: 1,
          perPage: 10,
          field: "creationDate",
          ascending: false,
        },
      };
    },
  
    watch: {
      state: {
        handler() {
          this.contractFetch();
        },
        deep: true,
      },
    },
  
    computed: {
      user() {
        return this.$store.state.user.informations;
      },
      contractGridData() {
        return this.contractHistory.map((user) => {
          const res = {};
          this.contractFields.forEach((field) => {
            if (this.contractFieldsGridFill[field]) {
              res[field] = this.contractFieldsGridFill[field](user);
            }
          });
          return res;
        });
      },
    },
  
    methods: {
      goToContract(reference) {
        this.$router.push(`/contracts/${reference}`);
      },
      showReason(reason) {
        this.selectedMotif = reason;
        this.$refs.reasonModal.openModal();
      },
      getStructureName(ref) {
        let name;
        this.allStructures.forEach((structure) => {
          if(structure.reference == ref) {
            name = structure.name;
          }
        })
        return name;
      },
      contractFetch() {
        this.loading = true;
        this.$services.contractRequestService
          .findAll(
            Object.assign({}, this.model, { applicantID : this.user.reference }),
            null,
            null,
            this.state.page,
            this.state.perPage,
            this.state.field,
            this.state.ascending,
            this.gridColumnsFields
          )
          .then((res) => {
            this.loading = false;
            this.count = res.data.count;
            this.contractHistory = res.data.data;
          });
          this.$services.structure
            .findAll()
            .then((response) => {
              this.allStructures = response.data;
            })
      },
    },
  
    mounted() {
      if (!this.reference) {
        this.model = { userReference: this.user.reference };
      } else {
        this.model = { userReference: this.reference };
      }
      this.contractFetch();
    },
  };
  </script>
  
<style>
.HistoryDemands-refuseButton {
  border: 1px #ABB6BF solid;
  color: #373a3d;
  /* font-size: 14px !important; */
  /* width: 50px !important; */
}
</style>